const BLOCKED_CONTENT_TAGS = [
  "script",
  "style",
  "iframe",
  "object",
  "embed",
  "form",
];

const normalizeAllowedTags = (allowedTags) => {
  if (!Array.isArray(allowedTags)) return null;
  return new Set(allowedTags.map((tag) => String(tag).toUpperCase()));
};

export const sanitizeHtml = (html, options = {}) => {
  if (!html || typeof html !== "string" || typeof DOMParser === "undefined") {
    return "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const allowedTags = normalizeAllowedTags(options.allowedTags);

  BLOCKED_CONTENT_TAGS.forEach((tag) => {
    doc.body.querySelectorAll(tag).forEach((node) => node.remove());
  });

  Array.from(doc.body.querySelectorAll("*"))
    .reverse()
    .forEach((node) => {
      if (allowedTags && !allowedTags.has(node.tagName)) {
        node.replaceWith(...Array.from(node.childNodes));
        return;
      }

      Array.from(node.attributes).forEach((attribute) => {
        if (allowedTags) {
          node.removeAttribute(attribute.name);
          return;
        }

        const name = attribute.name.toLowerCase();
        const value = attribute.value.trim().toLowerCase();
        const isEventHandler = name.startsWith("on");
        const isUnsafeUrl =
          ["href", "src", "xlink:href"].includes(name) &&
          (value.startsWith("javascript:") || value.startsWith("data:"));

        if (isEventHandler || isUnsafeUrl) {
          node.removeAttribute(attribute.name);
        }
      });
    });

  return doc.body.innerHTML;
};

export default sanitizeHtml;
